// extracted by mini-css-extract-plugin
export default {"summaryContainer":"Summary_summaryContainer__I-XOP","questions":"Summary_questions__L-QOI"};